import { Controller } from 'stimulus';
import { send, INTERACTION_TYPES } from '../javascripts/apopheniaLogger';

class CallProController extends Controller {
  static targets = ['number'];
  static values = { accountKey: String };

  revealNumber(e) {
    e.target.classList.add('button-is-hidden');
    this.numberTarget.style.display = 'block';

    this._log('desktop');
  }

  logClick() {
    this._log('mobile');
  }

  _log(screenSize) {
    send({
      interaction_type: INTERACTION_TYPES.CLICKED,
      account_key: this.accountKeyValue,
      screen_id: 'call_pro',
      screen_size: screenSize
    });
  }
}

export default CallProController;
